import { mapGetters } from 'vuex' 
import { getQuestionList } from '@/api/wenjuan/wjquestion.js'
import GlobalConfig from '@/global/config'
import { getStaffList } from '@/api/company/staff'
import { getFaceVerifyLastRecord } from '@/api/auth'
// import { verifyQingyanRelevantSurvey } from '@/api/survey'
import {checkVerifyFace} from '@/api/common'

export default {
  data() {
    return {
      faceRecognitionVisible: false
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    isQY() {
      return this.userInfo.isQY
    }
  },
  methods: {
    //返回true不需要人脸识别，反之需要
    async checkFace() {
      // const qY = await verifyQingyanRelevantSurvey(GlobalConfig.getSurveyId())
      // const isQY = qY.data.data
      if(!this.isQY) {
        return true
      }else {
        //校验白名单
        const white = await checkVerifyFace()
        console.log('white', white)
        if(white.data?.data?.verifyWhiteList) {
          return true
        }else {
          //当前人脸识别验证记录 时间是否【≤4小时】
          // const record = await getFaceVerifyLastRecord()
          // const update = new Date(record.data?.data?.updateTime).getTime()
          const update = new Date(white.data?.data?.lastFaceVerifyTime).getTime()
          const now = new Date().getTime()
          return now - update <= 3600000*4
        }
      }
    }
  },
}